import React from "react";

function HomePage() {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h2>My Website</h2>

        <nav>
          <a href="/" style={styles.link}>Home</a>
          <a href="/about" style={styles.link}>About</a>
          <a href="/services" style={styles.link}>Services</a>
          <a href="/contact" style={styles.link}>Contact</a>
        </nav>
      </header>

      <section style={styles.hero}>
        <h1 style={styles.title}>Welcome to My Homepage</h1>

        <p style={styles.subtitle}>
          React static homepage UI.
        </p>

        <button style={styles.button}>
          Get Started
        </button>
      </section>

      <footer style={styles.footer}>
        © 2026 My Website
      </footer>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "Arial",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
  },

  header: {
    backgroundColor: "#2563eb",
    color: "white",
    padding: "20px 40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  link: {
    color: "white",
    marginLeft: "20px",
    textDecoration: "none",
  },

  hero: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  title: {
    fontSize: "48px",
    marginBottom: "20px",
  },

  subtitle: {
    fontSize: "20px",
    marginBottom: "30px",
  },

  button: {
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  footer: {
    backgroundColor: "#111827",
    color: "white",
    textAlign: "center",
    padding: "15px",
  },
};

export default HomePage;